module.exports = __webpack_public_path__ + "static/media/phone.9da9cc1a.svg";